import { Helmet } from "react-helmet";
import React from "react";

import "./OngoingHospitalVerification.scss";
import * as services from "../../services";
import { MBContainer } from "../../components/MBContainer/MBContainer";
import { MBProps } from "../../interface";
import {
  IonCard,
  IonIcon,
  IonLabel,
  IonCardContent,
  IonButton,
} from "@ionic/react";
import { MBCOLORS } from "../../constants/config";

class OngoingHospitalVerification extends React.Component<MBProps> {
  onCLick = async () => {
    await services.signOut();
  };
  render = () => {
    return (
      <>
        <Helmet>
          <title>MedBook - Ongoing Verification</title>
        </Helmet>
        <MBContainer {...this.props}>
          <IonCard className="ongoing-verify-card" color={MBCOLORS.tertiary}>
            <IonCardContent className="ongoing-verify-card-content">
              <IonIcon className="verify-icon warning" />
              <IonLabel className="mb-h2 dark-blue">
                Ongoing Verification
              </IonLabel>
              <IonLabel className="resend-email-description mb-body">
                Hi! You account is still for verification, please wait till you
                get a notification that you can now operate. Thank you!
              </IonLabel>
              <IonButton
                mode="ios"
                className="verify-ok-button"
                color={MBCOLORS.primary}
                onClick={this.onCLick}
              >
                Thank you
              </IonButton>
            </IonCardContent>
          </IonCard>
        </MBContainer>
      </>
    );
  };
}

export default OngoingHospitalVerification;
